import { princetonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PrincetonPage() {
  return <CityPageTemplate config={princetonConfig} />;
}